import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import logger from 'redux-logger'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
// defaults to localStorage for web
import thunk from 'redux-thunk'
import { rootReducer } from './rootReducer'

const persistConfig = {
  key: 'root',
  whitelist: [],
  storage,
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

export const ConfigureStore = () => {
  let store = createStore(
    persistedReducer,
    composeWithDevTools(applyMiddleware(thunk, logger))
  )
  let persistor = persistStore(store)
  return { store, persistor }
}
